import { TableCollapsable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { useColumns } from '../hooks/useColumns';
import {
  PerformanceAnalysis,
  PerformanceAnalysisDetailRowModalData,
} from '../types';
import {
  PerformanceAnalysisDetailConsumer,
  PerformanceAnalysisDetailLoader,
} from './PerformanceAnalysisDetailLoader';
import { PerformanceAnalysisDetailTable } from './PerformanceAnalysisDetailTable';

export interface PerformanceAnalysisTableProps {
  data: PerformanceAnalysis[];
  loading: boolean;
  onShowModal: (data: PerformanceAnalysisDetailRowModalData) => void;
  onDownload: (data: PerformanceAnalysis) => void;
}

export function PerformanceAnalysisTable({
  data,
  loading,
  onShowModal,
  onDownload,
}: PerformanceAnalysisTableProps) {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS,
  );

  const table = useMemo(() => {
    return t<
      string,
      {
        noResults: string;
      }
    >('table', {
      returnObjects: true,
    });
  }, [t]);

  const columns = useColumns({ onShowModal, onDownload: onDownload });

  return (
    <TableCollapsable
      columns={columns}
      data={data}
      isLoading={loading}
      noResultsText={table.noResults}
      secondColumn={{
        tdClassName: 'px-4',
        columnName: 'second',
        headerText: 'second',
        cellFormat: ({ row }) => (
          <PerformanceAnalysisDetailLoader sectionId={row.sectionId}>
            <PerformanceAnalysisDetailConsumer>
              {({ data, loading }) => (
                <PerformanceAnalysisDetailTable data={data} loading={loading} />
              )}
            </PerformanceAnalysisDetailConsumer>
          </PerformanceAnalysisDetailLoader>
        ),
      }}
    />
  );
}
